import {
  collection,
  doc,
  addDoc,
  getDocs,
  updateDoc,
  query,
  where,
  orderBy,
  serverTimestamp,
} from 'firebase/firestore'
import { db } from '@/services/firebase/config'
import type { Offer, OfferStatus } from '@/types/offer'

const OFFERS_COLLECTION = 'offers'

export async function createOffer(
  listingId: string,
  listingTitle: string,
  buyerId: string,
  buyerName: string,
  sellerId: string,
  sellerName: string,
  amount: number,
  message?: string
): Promise<string> {
  const docRef = await addDoc(collection(db, OFFERS_COLLECTION), {
    listingId,
    listingTitle,
    buyerId,
    buyerName,
    sellerId,
    sellerName,
    amount,
    message: message || '',
    status: 'pending',
    createdAt: serverTimestamp(),
  })
  return docRef.id
}

export async function getOffersForListing(listingId: string): Promise<Offer[]> {
  const q = query(
    collection(db, OFFERS_COLLECTION),
    where('listingId', '==', listingId),
    orderBy('createdAt', 'desc')
  )
  const snapshot = await getDocs(q)
  return snapshot.docs.map((d) => ({ id: d.id, ...d.data() })) as Offer[]
}

export async function getOffersForBuyer(buyerId: string): Promise<Offer[]> {
  const q = query(
    collection(db, OFFERS_COLLECTION),
    where('buyerId', '==', buyerId),
    orderBy('createdAt', 'desc')
  )
  const snapshot = await getDocs(q)
  return snapshot.docs.map((d) => ({ id: d.id, ...d.data() })) as Offer[]
}

export async function getOffersForSeller(sellerId: string): Promise<Offer[]> {
  const q = query(
    collection(db, OFFERS_COLLECTION),
    where('sellerId', '==', sellerId),
    orderBy('createdAt', 'desc')
  )
  const snapshot = await getDocs(q)
  return snapshot.docs.map((d) => ({ id: d.id, ...d.data() })) as Offer[]
}

export async function respondToOffer(
  offerId: string,
  status: OfferStatus,
  counterAmount?: number,
  counterMessage?: string
): Promise<void> {
  const updates: Record<string, unknown> = {
    status,
    updatedAt: serverTimestamp(),
  }
  if (counterAmount !== undefined) updates.counterAmount = counterAmount
  if (counterMessage !== undefined) updates.counterMessage = counterMessage
  await updateDoc(doc(db, OFFERS_COLLECTION, offerId), updates)
}

export async function withdrawOffer(offerId: string): Promise<void> {
  await updateDoc(doc(db, OFFERS_COLLECTION, offerId), {
    status: 'withdrawn',
    updatedAt: serverTimestamp(),
  })
}
